import axios, { AxiosProgressEvent } from 'axios';
import {
  FileUploadSettingErrorMessageKey,
  PiclibFileUploadMediaFormat,
} from 'models';

export type HandleUploadFileResponse = {
  mediaFileMetadata: {
    id: string;
    // form srn
    libraryId: string;
    submissionId: string;
    // fileName
    subjectId: string;
    attributeMap: {
      // 入っているのはnumber
      FILE_SIZE: string;
      MEDIA_FORMAT: PiclibFileUploadMediaFormat;
      ORIGINAL_NAME: string;
      // date
      LAST_MODIFICATION_DATE_TIME: string;
    };
  };
};

export type HandleUploadFileErrorResponse = {
  error: {
    name: 'ValidateUploadedMediaFile';
    type: FileUploadSettingErrorMessageKey;
  };
};

export type HandleUploadFilePayload = {
  apiRoot: string;
  submissionId: string;
  subjectId: string;
  onProgress?: (progressEvent: AxiosProgressEvent) => void;
};

const getUrl = ({
  apiRoot,
  submissionId,
  subjectId,
}: Omit<HandleUploadFilePayload, 'onProgress'>) =>
  `${apiRoot}v1/sessions/${submissionId}/media-files/${subjectId}`;

export const validateUploadFile = async (
  props: HandleUploadFilePayload
): Promise<HandleUploadFileResponse> => {
  const url = getUrl(props);
  const result = await axios.put(
    url,
    {},
    {
      onUploadProgress(e: AxiosProgressEvent) {
        props.onProgress?.(e);
      },
    }
  );
  return result.data;
};

export const deleteUploadFile = async (
  props: HandleUploadFilePayload
): Promise<HandleUploadFileResponse> => {
  const url = getUrl(props);
  const result = await axios.delete(url);
  return result.data;
};
